import moment from 'moment'
import http from './http'
const parkingAvailabilityRoute = '/parking/availability/'
const extraAvailabilityRoute = '/extra/availability/'
const loungeAvailabilityRoute = '/extra/loungeavailability/'
const fastTrackAvailabilityRoute = '/extra/fasttrackavailability/'

export default {
    async getParkingAvailability (query) {
        return this.get(query, parkingAvailabilityRoute)
    },
    async getExtraAvailability (query) {
        return this.get(query, extraAvailabilityRoute)
    },
    async getLoungeAvailability (query) {
        return this.get(query, loungeAvailabilityRoute)
    },
    async getFastTrackAvailability (query) {
        return this.getFastTrack(query, fastTrackAvailabilityRoute)
    },
    async get (query, route) {
        let routeAndQuery = route +
            '?airportcode=' + query.airportCode +
            '&terminalid=' + query.terminalId
        if (query.entryDateTime && moment(query.entryDateTime).isValid()) {
            routeAndQuery = routeAndQuery + '&entrydatetime=' + moment(query.entryDateTime).utc().format('YYYY-MM-DDTHH:mm:ss')
        }
        if (query.exitDateTime && moment(query.exitDateTime).isValid()) {
            routeAndQuery = routeAndQuery + '&exitdatetime=' + moment(query.exitDateTime).utc().format('YYYY-MM-DDTHH:mm:ss')
        } else if (query.entryDateTime && moment(query.entryDateTime).isValid()) {
            routeAndQuery = routeAndQuery + '&exitdatetime=' + moment(query.entryDateTime).utc().format('YYYY-MM-DDTHH:mm:ss')
        }
        if (query.productId !== undefined) { routeAndQuery += '&productid=' + query.productId }
        if (query.categoryId !== undefined) { routeAndQuery += '&categoryid=' + query.categoryId }
        if (query.bookingGuid !== undefined) { routeAndQuery += '&bookingguid=' + query.bookingGuid }
        if (query.promoCode !== undefined) { routeAndQuery += '&promotioncode=' + query.promoCode }
        if (query.quantities !== undefined) {
            for (let i = 0; i < query.quantities.length; i++) { routeAndQuery += '&quantities[' + i + ']=' + query.quantities[i] }
        }
        if (query.travelDirection !== undefined) { routeAndQuery += '&traveldirection=' + query.travelDirection }
        return http.get(routeAndQuery)
    },
    async getFastTrack (query, route) {
        let routeAndQuery = route +
            '?airportcode=' + query.airportCode +
            '&terminalid=' + query.terminalId
        if (query.entryDateTime) {
            routeAndQuery = routeAndQuery + '&entrydatetime=' + moment(query.entryDateTime).utc().format('YYYY-MM-DDTHH:mm:ss')
        }
        if (query.exitDateTime) {
            routeAndQuery = routeAndQuery + '&exitdatetime=' + moment(query.exitDateTime).utc().format('YYYY-MM-DDTHH:mm:ss')
        }
        if (query.productId !== undefined) { routeAndQuery += '&productid=' + query.productId }
        if (query.categoryId !== undefined) { routeAndQuery += '&categoryid=' + query.categoryId }
        if (query.bookingGuid !== undefined) { routeAndQuery += '&bookingguid=' + query.bookingGuid }
        if (query.promoCode !== undefined) { routeAndQuery += '&promotioncode=' + query.promoCode }
        if (query.quantities !== undefined) {
            for (let i = 0; i < query.quantities.length; i++) { routeAndQuery += '&quantities[' + i + ']=' + query.quantities[i] }
        }
        if (query.travelDirection !== undefined) { routeAndQuery += '&traveldirection=' + query.travelDirection }
        return http.get(routeAndQuery)
    }
}
